import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

export default (makeCall: MakeCall) => (listingId: number) =>
  makeCall<undefined>('PUT', `${APIV2_URL}/listing/${listingId}/show`);

export type ShowListingCall = (listingId: number) => Promise<void>;
